export default "__VITE_ASSET__Dpx$i8K0__"